import { Component, OnInit, Inject, ViewChild, ElementRef, AfterViewInit, Output, EventEmitter } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { InventorySource } from 'src/app/acumatica/EntityServices/OrderPicking.service';
import { InventoryAdjustmentEditorComponent } from 'src/app/common/inventory-adjustment-editor/inventory-adjustment-editor.component';
import { InventoryLocationEditorComponent } from '../../../common/inventory-location-editor/inventory-location-editor.component';
import { MatButtonToggleChange } from '@angular/material/button-toggle';

@Component({
  templateUrl: './edit-inventory-dialog.component.html',
  styleUrls: ['./edit-inventory-dialog.component.css']
})
export class EditInventoryDialog implements AfterViewInit {
  /** Event emitted when a printer QR code is scanned */
  @Output() OnPrinterScanned = new EventEmitter<string | null>();

  @ViewChild('inventoryAdjustment') inventoryAdjustment!: InventoryAdjustmentEditorComponent;
  @ViewChild('restockLocationComponent') inventoryLocation!: InventoryLocationEditorComponent;

  source!: InventorySource;
  warehouseLocations!: string[];
  get needPieceRestock(): boolean { return this.source.QtyOnHand > 0; }

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: {
      source: InventorySource,
      warehouseLocations: string[]
    },
    public dialogRef: MatDialogRef<EditInventoryDialog>,
  ) {
    this.source = data.source;
    this.warehouseLocations = data.warehouseLocations;
  }

  ngAfterViewInit(): void { this.focusAdjustmentQty(); }
  focusAdjustmentQty() { setTimeout(() => this.inventoryAdjustment.focus(), 100); }
  focusRestockLocation() { setTimeout(() => this.inventoryLocation.focus(), 100); }

  pieceRestocked(location: string) {
    this.source.LocationID = location;
    this.dialogRef.close('complete');
  }

  onPrinterScanned(printer: string | number | null) {
    this.OnPrinterScanned.emit(printer!.toString());
    setTimeout(() => {
      this.inventoryLocation.focus();
    }, 100);
  }

  commercialMatchToggleChange(event: MatButtonToggleChange, inventorySource: InventorySource) {
    inventorySource.CommercialMatch = event.value;
    if (this.source.hasAdjustment) this.focusRestockLocation();
    else this.focusAdjustmentQty();
  }

}
